const HEAT_CYCLE_INFO = [
    {
        title: "Swelling of the Vulva",
        description: "This might not be obvious, especially if you're not an experienced dog owner."
    },
    {
        title: "Increased Licking Behavior",
        description: "Female dogs will lick themselves more often."
    },
    {
        title: "Vaginal Discharge",
        description: "During heat, a dog may have vaginal discharge or light bleeding."
    },
    {
        title: "Mood Changes",
        description: "A dog can get more clingy or, on the other hand, needs more space or become grumpy."
    },
    {
        title: "Appetite Change",
        description: "A bitch can refuse to eat her usual dog food or become hungrier."
    },
    {
        title: "Tail Tucking at the Beginning",
        description: "Usually becomes tail flagging when a bitch reaches the estrus state."
    },
    {
        title: "Flirting with other dogs",
        description: "A female dog may flirt with other dogs by being more playful, and seeking their company."
    }
];

export default HEAT_CYCLE_INFO;